/* eslint-disable import/no-default-export */
import { ossUrl } from '@/defines/environment/config'
const bannerUrl = `${ossUrl}weixin/mall/cdn/images/default/bg_popheader.png`

const calcGoodList = list => {
  const calcSkuList = list.map(ssuItem => {
    const ssu = Object.assign({}, ssuItem, {
      ssuInfo: ssuItem?.ssuList ? ssuItem?.ssuList[0] : {}
    })
    return ssu
  })
  return calcSkuList
}

export default {
  updateShopId(state, id) {
    state.shop.id = id
  },
  updateShopInfo(state, info) {
    state.shop.name = info.shop_name || ''
    state.shop.desc = info.shop_desc || ''
    state.shop.url = info.shop_url || ''
    state.shop.bannerUrl = info?.shop_banners[0] || bannerUrl
    state.shop.logoUrl = info.shop_logo || ''
    state.shop.saleLimitAmount = info.sale_limit_amount || 0
    state.shop.closeStoreTime = info.close_store_time || ''
    state.shop.shopInvoiceWay = info.shop_invoice_way || 0
    state.shop.shopInvoiceWayText = info.shop_invoice_way_text || ''
    state.shop.isShowInvoiceWayText = info.is_show_invoice_way_text || 0
    state.shop.openInfo = info.open_info || {}
    state.shop.invoiceTag = info.invoiceTag || null
    // 商品经营信息相关信息
    state.personShopInfo.isPersonShop = info.biz_type === 3 // 1 个体工商户，2 企业  3 个人店/无执照
    state.personShopInfo.showPersonShopDetail = info.show_personal_style === 1 // 1表示展示商家资质跳转样式，0不跳转样式
    state.personShopInfo.shopName = info.shop_name || ''
    state.personShopInfo.address = info.address || ''
    state.personShopInfo.contactPhone = info.contact_phone || ''
    state.personShopInfo.personalTip = info.personal_tip || ''
  },
  updateShopQualification(state, info) {
    state.qualification.showBizLicense = Number(info.show_biz) === 1
    state.qualification.bizLicense = {
      companyName: info.name || '',
      code: info.biz_code || '',
      pic: info.biz_pic || ''
    }
    state.qualification.otherLicenses = Array.isArray(
      info.pop_credentials_bean_list
    )
      ? info.pop_credentials_bean_list.map(item => ({
          name: item.name || '',
          pic: item.pic || '',
          type: item.type || '',
          picList: item.picList || []
        }))
      : []
    state.qualification.bizClass = Array.isArray(info.business_class_info_list)
      ? info.business_class_info_list
      : []
  },
  classInit(state, action) {
    const class2List = [
      {
        id: 0,
        parent_id: 0,
        name: '全部'
      }
    ]
    action.map(class1List => {
      ;(class1List.class2List || []).map(item => {
        class2List.push(item)
      })
    })
    state.class2List = class2List
  },
  navListBuild(state, action) {
    state.class2List = action.list
  },
  navListUpdate(state, payload) {
    payload.forEach(item => {
      state[item.key] = item.value
    })
  },
  filterOpen(state, action) {
    if (action === undefined) {
      state.filterOpen = !state.filterOpen
    } else {
      state.filterOpen = action
    }
  },
  filterListInit(state, action) {
    state.filterList = action.filterList || []
    state.filterKey = []
    state.brandList = action.brandList || []
    state.selectedBrand = ''
  },
  filterInit(state, action) {
    state.filterOpen = false
    state.scoreOpen = false
    state.filterKey = []
    state.selectedBrand = ''
  },
  filterSelect(state, action) {
    if (action === 0) {
      state.filterKey = []
    } else {
      state.filterKey = [...action]
    }
  },
  brandSelect(state, action = '') {
    state.selectedBrand = action
  },
  initeSkuList(state, action) {
    const firstPage = state.queryData.page === 1
    const skuLists = calcGoodList(action.skuList || [])
    if (!skuLists.length) {
      state.hasFinished = true
    }
    if (firstPage) {
      state.searchSkuList = skuLists
    } else {
      state.searchSkuList = state.searchSkuList.concat(skuLists)
    }
    state.hasFinished = !!action.isLast
    state.brandList = action.brandList
    state.filterList = action.biList
    if (!state.searchSkuList.length) {
      state.hasFinished = true
    }
  },
  setActQueryData(state, data) {
    state.queryData = Object.assign(state.queryData, data)
  },
  loadingSwitch(state, action) {
    state.loading = action
  },
  clearQueryData(state, action) {
    state.queryData.bottomPrice = ''
    state.queryData.topPrice = ''
    state.queryData.saleC1Id = 0
    state.queryData.saleC2Id = 0
    state.queryData.sortType = ''
    state.queryData.keyword = ''
    state.queryData.brands = []
    state.queryData.biNames = []
    state.filterList = []
    state.filterKey = []
    state.brandList = []
    state.selectedBrand = ''
    state.minPrice = ''
    state.maxPrice = ''
    state.keyword = ''
    state.class2Name = '全部'
    state.filterSort = false
  },
  clearData(state) {
    state.class2List = []
    state.class2Index = -1
    state.class2Name = '全部'
    state.filterOpen = false
    state.filterList = []
    state.filterKey = []
    state.brandList = []
    state.selectedBrand = ''
    state.searchSkuList = []
    state.pageNo = 1
    state.loading = true
    state.queryData = {}
    state.filterSort = false
    state.hasFinished = false
    state.minPrice = ''
    state.maxPrice = ''
    state.keyword = ''
    state.saleC1Id = ''
  },
  setFilterSort(state, action) {
    state.filterSort = action
  },
  setPrice(state, action) {
    state[action.type] = action.value
  },
  setKeyWord(state, action) {
    state.keyword = action
  },
  setSallClass1Id(state, action) {
    state.saleC1Id = action
  },
  clearClass2Index(state, action) {
    state.class2Index = -1
  },
  clearStateData(state, action) {
    state.clearStateData = action
  },
  updateRiskInfo(state, data) {
    state.riskInfo.riskId = data?.risk_id || ''
    state.riskInfo.url = data?.url || ''
    state.riskInfo.isShowVerifyModel = true
  },
  clearRiskInfo(state) {
    state.riskInfo.riskId = ''
    state.riskInfo.url = ''
    state.riskInfo.isShowVerifyModel = false
  }
}
